<template>
  <div id="admin-paper-edit">
    <!-- 编辑试卷界面 -->
    <div class="content" v-loading="loading">
      <div class="goback" @click="goback">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>
      <div class="con">
        <div
          :class="{ line: true, 'line-half': !item.ishe }"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="title">
            <span v-if="item.title != ''"
              ><span v-if="item.isNotNull" class="xx">*</span
              >{{ item.title }}:</span
            >
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.title"
              clearable
            ></el-input>
          </div>

          <div class="value" v-if="item.type == 'selects'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.title"
              multiple
              clearable
              filterable
            >
              <el-option
                v-for="it in item.option"
                :key="it.id"
                :label="it.name"
                :value="it.id"
              >
              </el-option>
            </el-select>
          </div>

          <div class="value bj" v-if="item.type == 'selects-linkage'">
            <div class="ll" v-for="(it, ii) in item.value" :key="ii">
              <div class="li-va">
                <el-select
                  v-model="it.subjectId"
                  placeholder="请选择"
                  @change="changeSubjectPeo(item.value)"
                >
                  <el-option
                    v-for="it in item.option"
                    :key="it.id"
                    :label="it.name"
                    :value="it.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="li-va">
                <el-input
                  v-model="it.proportion"
                  :placeholder="'请输入科目比例'"
                  clearable
                ></el-input>
              </div>
              <div class="li-va">
                <div class="add_but1" @click="addSubject">
                  <i class="el-icon-plus"></i>添加科目
                </div>
                <div class="add_but1" v-if="ii > 0" @click="removeSubject(ii)">
                  <i class="el-icon-plus"></i>移除科目
                </div>
              </div>
            </div>
          </div>
          <div class="value bj" v-if="item.type == 'distribute'">
            <!-- 题型分布 -->
            <div class="ll" v-for="(it, ii) in item.value" :key="ii">
              <div class="li-va">
                <div class="li-ll">
                  <div class="li-ll-ti">题型:</div>
                  <div class="li-ll-va">
                    <el-select v-model="it.type" placeholder="请选择">
                      <el-option
                        v-for="tt in questionType"
                        :key="tt.value"
                        :label="tt.label"
                        :value="tt.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="li-ll"></div>
                <div class="li-ll">
                  <div class="li-ll-ti">数量:</div>
                  <div class="li-ll-va">
                    <el-input
                      v-model="it.num"
                      placeholder="请输入数量"
                    ></el-input>
                  </div>
                </div>
                <div class="li-ll">
                  <div class="li-ll-ti">分值:</div>
                  <div class="li-ll-va">
                    <el-input
                      v-model="it.typeTotalPoints"
                      placeholder="请输入总分"
                    ></el-input>
                  </div>
                </div>
                <div
                  class="add_but"
                  @click="removePaperOptions(item.value, ii)"
                >
                  <i class="el-icon-minus"></i>移除题型
                </div>
              </div>
            </div>
            <div class="add_but" @click="addPaperOptions(item.value)">
              <i class="el-icon-plus"></i>添加题型
            </div>
          </div>
        </div>
        <div class="line">
          <div class="title">试题</div>
          <div class="add_but" @click="creatrPaper">生成试卷</div>
        </div>
        <div class="line">
          <div class="title"></div>
          <div class="value">
            <div class="details" @click="showPaper">查看详情</div>
          </div>
        </div>
        <div class="line">
          <div class="title"></div>
          <div class="add_but" @click="submit">
            <i class="el-icon-check"></i> 提交
          </div>
        </div>
      </div>
    </div>
    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as paperData from "./js/paper.js";
import * as questionData from "../question_bank/js/question.js";
export default {
  data() {
    return {
      loading: false,
      currentDate: new Date(),
      pickerOptions: {
        disabledDate(time) {
          // 禁用小于当前日期的时间
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      id: "",
      data: paperData.getPaperEditPageData(),
      questionType: this.$questionType,
      testPaper: [],
      dialogData: {
        flag: false,
        title: "生成试卷",
        width: "50%",
        tempData: {},
        dialogData: [{ type: "test-paper", value: [] }],
        buttonList: [
          { text: "确定", active: "makesure_add_child_pro" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 获取所有科目
     */
    async getAllSubjectForSelect() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: null,
        });
        this.data.forEach((element) => {
          if (element.key == "subject") {
            element.option = resultData;
          }
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取试卷详情
     */
    async showTestPaperById() {
      try {
        let resultData = await this.$request({
          url: "/testPaper/showTestPaperById",
          method: "post",
          data: { id: this.id },
        });
        // 手动处理questionDistribute 题型分布
        let questionDistribute = [];
        resultData.testPaper.forEach((element) => {
          let dd = {
            type: element.type,
            num: element.item.length,
            typeTotalPoints: element.typeTotalPoints,
          };
          questionDistribute.push(dd);
        });
        this.$set(resultData, "questionDistribute", questionDistribute);
        this.data = this.$baseData.json2array(this.data, resultData);
        this.testPaper = resultData.testPaper;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 添加题型
     */
    addPaperOptions(array) {
      let flag = this.judegePaperType(array);
      if (flag != "0") {
        this.$message.warning(flag);
        return;
      }
      let dd = {
        type: "",
        num: "",
        typeTotalPoints: "",
      };
      array.push(dd);
    },
    /**
     * 移除题型
     */
    removePaperOptions(array, index) {
      array.splice(index, 1);
    },
    /**
     * 判断题型内不可为空
     */
    judegePaperType(array) {
      try {
        array.forEach((element) => {
          if (element.type == "") {
            throw "题型不可空";
          }
          if (element.num == "") {
            throw "数量不可空";
          }
          if (isNaN(element.num)) {
            throw "数量只能为数字";
          }
          if (element.typeTotalPoints == "") {
            throw "分值不可空";
          }
          if (isNaN(element.typeTotalPoints)) {
            throw "分值只能为数字";
          }
        });
        return "0";
      } catch (error) {
        return error;
      }
    },
    /**
     * 生成试卷
     */
    async creatrPaper() {
      try {
        let requestData = {};
        // 1.非空判断
        let flag = this.judegeNotNull();
        if (flag != "0") {
          this.$message.warning(flag);
          return;
        }
        requestData = this.$baseData.array2json(this.data, requestData);
        // 2.判断各题型中总分是否为试卷总分
        let tempTotal = 0; // 临时存储各题型的总分
        requestData.questionDistribute.forEach((element) => {
          tempTotal += parseFloat(element.typeTotalPoints);
        });
        console.log("各题型总分:", tempTotal);
        if (tempTotal != requestData.totalPoints) {
          this.$message.warning(
            "当前试卷所选题型总分与当前试卷设置总分不一致.请调整后重新生成试卷!"
          );
          return;
        }
        let resultData = await this.$request({
          url: "/testPaper/automaticGenerationPaper",
          method: "post",
          data: requestData,
        });
        this.testPaper = resultData;
        this.dialogData.title = "生成试卷";
        this.dialogData.dialogData = [
          { type: "test-paper", value: resultData },
        ];
        this.dialogData.buttonList = [
          { text: "确定", active: "makesure_add_parper" },
          { text: "取消", active: "cancel" },
        ];
        sessionStorage.setItem(
          "tempSubject",
          JSON.stringify(requestData.subject)
        );
        this.dialogData.flag = true;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 查看试卷详情
     */
    async showPaper() {
      try {
        /**
         * 1 判断试卷是否生成
         *    id为空,添加试卷
         *        testPaper为空,添加试卷,且没有生成试卷
         *    id不为空,编辑试卷
         *        调用接口,查看试卷详情
         */
        if (this.id == "" && this.testPaper.length == 0) {
          throw "请先生成试卷!";
        }
        this.dialogData.title = "查看试卷详情";
        this.dialogData.dialogData = [
          { type: "test-paper", value: this.testPaper },
        ];
        this.dialogData.buttonList = [
          { text: "确定", active: "makesure_add_parper" },
          { text: "取消", active: "cancel" },
        ];

        let requestData = {};
        requestData = this.$baseData.array2json(this.data, requestData);
        sessionStorage.setItem(
          "tempSubject",
          JSON.stringify(requestData.subject)
        );

        this.dialogData.flag = true;
        console.log("查看试卷详情");
      } catch (error) {
        this.$message.error(error);
      }
    },
    /**
     * 提交前的非空判断
     */
    judegeNotNull() {
      try {
        this.data.forEach((element) => {
          if (
            element.isNotNull &&
            (element.value == "" || element.value.length == 0)
          ) {
            throw element.title + "不可为空!";
          }
          if (element.key == "questionDistribute") {
            let f = this.judegePaperType(element.value);
            if (f != "0") {
              throw f;
            }
          }
        });
        return "0";
      } catch (error) {
        return error;
      }
    },
    /**
     * 自动获取科目占比
     */
    async changeSubjectPeo(subject) {
      try {
        let subjectIds = [];
        subject.forEach((element) => {
          subjectIds.push(element.subjectId);
        });
        let requestData = {
          subjectIds: subjectIds,
        };
        let resultData = await this.$request({
          url: "/testPaper/getSubjectProportion",
          method: "post",
          data: requestData,
        });
        this.data[2].value = resultData;
      } catch (error) {
        this.$message.warning(error.message);
      }
    },
    /**
     * 添加科目
     */
    addSubject() {
      try {
        this.data.forEach((element) => {
          if (element.key == "subject") {
            // 科目
            element.value.forEach((ele) => {
              if (ele.subjectId == "") {
                throw "科目ID不可为空";
              }
            });
          }
        });
        this.data.forEach((element) => {
          if (element.key == "subject") {
            // 科目
            let dd = { subjectId: "", proportion: "0" };
            element.value.push(dd);
            throw "";
          }
        });
      } catch (error) {
        if (error != "") {
          this.$message.warning(error);
        }
      }
    },
    /**
     * 移除科目
     */
    removeSubject(index) {
      try {
        this.data.forEach((element) => {
          if (element.key == "subject") {
            // 科目
            element.value.splice(index, 1);
            throw "";
          }
        });
      } catch (error) {}
    },
    /**
     * 提交
     */
    async submit() {
      if (await this.saveOrUpdateTestPaper()) {
        this.$router.back();
      }
    },
    /**
     * 弹出框的关闭事件
     */
    async dialogOper(active) {
      try {
        switch (active) {
          case "cancel":
            this.colseDialog();
            break;
          case "makesure_add_parper":
            // 确定添加试卷
            // await this.saveOrUpdateTestPaper();
            // 判断各题型下所有题的分值是否等于该题型的总分
            console.log("确定添加试卷", this.testPaper);
            this.testPaper.forEach((element) => {
              let tempTotal = 0;
              element.item.forEach((ele) => {
                tempTotal += parseFloat(ele.points);
              });
              if (tempTotal != element.typeTotalPoints) {
                console.log(tempTotal, element.typeTotalPoints);
                throw (
                  questionData.initTableValue("topic", element.type) +
                  "总分与设置的题型总分不等,请重新调整分值!"
                );
              }
            });
            sessionStorage.removeItem("tempSubject");
            this.dialogData.flag = false;
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.warning(error);
      }
    },
    async saveOrUpdateTestPaper() {
      try {
        let requestData = {
          id: this.id,
        };
        // 1.非空判断
        let flag = this.judegeNotNull();
        if (flag != "0") {
          this.$message.warning(flag);
          return;
        }
        requestData = this.$baseData.array2json(this.data, requestData);
        if (this.testPaper.length == 0) {
          this.$message.warning("请先生成试卷!");
          return;
        }
        this.$set(requestData, "testPaper", this.testPaper);
        console.log(requestData);
        let resultData = await this.$request({
          url: "/testPaper/saveOrUpdateTestPaper",
          method: "post",
          data: requestData,
        });
        return true;
      } catch (error) {
        this.$message.error(error.message);
        return false;
      }
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$confirm(
        "离开页面会丢失当前编辑的内容,是否保存当前编辑的内容?",
        "您即将离开编辑页面",
        {
          confirmButtonText: "保存",
          cancelButtonText: "返回",
          type: "warning",
        }
      )
        .then(async () => {
          // 保存
          await this.submit();
        })
        .catch(() => {
          this.$router.back();
        });
    },
    /**
     * 关闭弹出框
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    this.id = this.$route.query.id;
    await this.getAllSubjectForSelect();
    if (this.id != "") {
      await this.showTestPaperById();
    }
  },
};
</script>

<style lang="less" scoped>
#admin-paper-edit {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    > .con {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      overflow-y: auto;
    }
    .line {
      width: 100%;
      min-height: 45px;
      display: flex;
      margin-bottom: 15px;
      padding-right: 30px;
      box-sizing: border-box;
      .title {
        width: 180px;
        line-height: 35px;
        text-align: center;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        font-size: 145x;
        font-weight: bold;
        margin-right: 10px;
      }
      .value {
        width: 0;
        flex: 1;
        height: auto;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        /deep/ .el-input__inner,
        .el-radio-group {
          height: 35px;
        }
        /deep/ .el-select .el-input .el-select__caret,
        .el-radio-group,
        .el-input__icon {
          display: flex;
          align-items: center;
        }
        /deep/ .el-date-editor.el-input,
        .el-date-editor.el-input__inner,
        .el-select {
          width: 100%;
        }
        /deep/.el-date-picker {
          width: auto;
        }
      }
      > .bj {
        background-color: #f1f1f1;
        flex-direction: column;

        > .ll {
          width: 100%;
          height: auto;
          display: flex;
          align-items: center;
          margin: 10px 0;
          > .li-va {
            width: 0;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding: 0 10px;
            box-sizing: border-box;
            > .li-ll {
              width: 50%;
              height: 40px;
              display: flex;
              align-items: center;
              > .li-ll-ti {
                width: 100px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-right: 10px;
                font-size: 15px;
                font-weight: bold;
              }
              > .li-ll-va {
                width: 0;
                flex: 1;
                height: 100%;
                display: flex;
                align-items: center;
              }
            }
            > .add_but1 {
              height: 40px;
              border: 1px solid#02386e;
              color: #02386e;
              font-size: 15px;
              padding: 3px 38px;
              box-sizing: border-box;
              margin: 0 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;
              cursor: pointer;
              transition: 0.3s;
            }
          }
        }
      }
      .details {
        font-size: 14px;
        margin-left: 15px;
        color: rgb(92, 172, 247);
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          text-decoration: underline;
          text-underline-offset: 5px;
        }
      }
    }
    .line-half {
      width: 50%;
      display: flex;
      > .tt {
        margin-left: 20px;
        display: flex;
        align-items: center;
        line-height: 35px;
        text-align: center;
        justify-content: flex-start;
      }
    }
    .kc {
      flex-direction: column;
      > .va {
        width: 100%;
        height: 35px;
        display: flex;
        font-size: 15px;
        align-items: center;
        margin-bottom: 10px;
        > .ti {
          margin: 0 10px;
        }
        i {
          font-size: 20px;
          margin-left: 15px;
          cursor: pointer;
        }
      }
    }
  }

  .xx {
    color: #f00;
    font-size: 20px;
    margin-top: 4px;
    margin-right: 8px;
  }
}
</style>